'use strict'; // eslint-disable-line strict

Object.defineProperty(exports, '__esModule', {
  value: true
});

function get(object, property, defaultValue) {
  // eslint-disable-next-line eqeqeq,no-eq-null
  if (object != null && object.hasOwnProperty(property)) {
    return object[property];
  }
  return defaultValue;
}

function getIn(object, propertyPath, defaultValue) {
  var currObject = object; // eslint-disable-line no-var

  // eslint-disable-next-line eqeqeq,no-eq-null
  if (!Array.isArray(propertyPath)) {
    return defaultValue;
  }

  for (var i = 0; i < propertyPath.length; i++) { // eslint-disable-line no-var,vars-on-top
    var segment = propertyPath[i]; // eslint-disable-line no-var,vars-on-top
    // eslint-disable-next-line eqeqeq,no-eq-null
    if (currObject != null && currObject.hasOwnProperty(segment)) {
      currObject = currObject[segment];
    } else {
      return defaultValue;
    }
  }
  return currObject;
}

exports.get = get;
exports.getIn = getIn;
